import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import { Formik, Form } from 'formik';
import React__default, { Fragment, Component } from 'react';
import PropTypes from '../../node_modules/prop-types/index.js';
import Button from '../buttons/button.component.js';
import ButtonSubmit from '../buttons/button-submit.component.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * @deprecated
 */

var FormContainer = /*#__PURE__*/function (_Component) {
  _inherits(FormContainer, _Component);
  var _super = _createSuper(FormContainer);
  function FormContainer(props) {
    var _this;
    _classCallCheck(this, FormContainer);
    _this = _super.call(this, props);
    _this.state = {
      isValid: false
    };
    return _this;
  }
  _createClass(FormContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        initialValues = _this$props.initialValues,
        validateOnMount = _this$props.validateOnMount,
        enableReinitialize = _this$props.enableReinitialize,
        handleSubmit = _this$props.handleSubmit,
        children = _this$props.children;
      _this$props.formStyles;
      var hasButton = _this$props.hasButton,
        additionalValues = _this$props.additionalValues,
        validationSchema = _this$props.validationSchema,
        _this$props$loadingSt = _this$props.loadingState,
        loadingState = _this$props$loadingSt === void 0 ? false : _this$props$loadingSt,
        canSubmit = _this$props.canSubmit;
      _this$props.alignRight;
      _this$props.noMarginTop;
      _this$props.fullWidthBtn;
      var marginTop = _this$props.marginTop,
        btnStyle = _this$props.btnStyle,
        extraValidator = _this$props.extraValidator;
      _this$props.hasBackButton;
      _this$props.btnBackStyle;
      _this$props.backBtnLink;
      var alwaysBtnEnabled = _this$props.alwaysBtnEnabled,
        btnCallback = _this$props.btnCallback,
        fontFamily = _this$props.fontFamily,
        renderKey = _this$props.renderKey;
      return /*#__PURE__*/React__default.createElement(Formik, {
        initialValues: initialValues,
        validationSchema: validationSchema,
        validateOnMount: validateOnMount,
        enableReinitialize: enableReinitialize,
        onSubmit: function onSubmit(values, _ref, cb) {
          var setSubmitting = _ref.setSubmitting;
          setSubmitting(false);
          handleSubmit(_objectSpread(_objectSpread({}, values), additionalValues), cb);
        }
      }, function (_ref2) {
        _ref2.isSubmitting;
        _ref2.values;
        _ref2.errors;
        var isValid = _ref2.isValid;
        _ref2.validateForm;
        return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Form, {
          key: renderKey,
          style: _objectSpread({
            width: "100%"
          }, _this2.props.style)
        }, children, /*#__PURE__*/React__default.createElement("div", {
          style: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            marginTop: marginTop ? marginTop : "24px"
          }
        }, hasButton && canSubmit !== false ? isValid && !loadingState && (extraValidator == null || extraValidator != null && extraValidator == true) ? /*#__PURE__*/React__default.createElement(ButtonSubmit, {
          style: _objectSpread({
            width: "100%"
          }, btnStyle),
          fontFamily: fontFamily,
          type: "primary",
          color: "green",
          borderRadiusType: hasButton && hasButton.isFromSite ? "rounded" : "smallRounded",
          heightButton: "large",
          text: hasButton.text,
          active: isValid && !loadingState && !hasButton.disabled && (extraValidator == null || extraValidator != null && extraValidator == true) || alwaysBtnEnabled ? "true" : "false",
          containerButtonStyle: {
            width: "100%"
          },
          blockMobileScale: true
        }) : /*#__PURE__*/React__default.createElement(Button, {
          style: _objectSpread({
            width: "100%"
          }, btnStyle),
          fontFamily: fontFamily,
          type: "primary",
          color: "green",
          borderRadiusType: hasButton && hasButton.isFromSite ? "rounded" : "smallRounded",
          text: hasButton.text,
          onClick: btnCallback,
          heightButton: "large",
          active: isValid && !loadingState && !hasButton.disabled && (extraValidator == null || extraValidator != null && extraValidator == true) || alwaysBtnEnabled ? "true" : "false",
          containerButtonStyle: {
            width: "100%"
          },
          blockMobileScale: true
        }) : null)));
      });
    }
  }]);
  return FormContainer;
}(Component);
FormContainer.propTypes = {
  initialValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  formStyles: PropTypes.string,
  hasButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  }),
  validationSchema: PropTypes.func,
  additionalValues: PropTypes.object,
  canSubmit: PropTypes.bool,
  alignRight: PropTypes.bool,
  alignCenter: PropTypes.bool,
  noMarginTop: PropTypes.bool
};
FormContainer.defaultProps = {
  additionalValues: {},
  alwaysBtnEnabled: false
};
export { FormContainer as default };